import { useEffect, useState } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL, SENDRESPONSE } from "../../../API/API";
import { toast } from "react-toastify";

export default function ResponsMessage({ setmessage, message, selectId, onSuccess }) {
  const axiosPrivate = useAxiosPrivate();
  const [messages, setmessages] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const resetForm = () => {
    setmessages("");
    setSuccessMessage("");
    setErrorMessage("");
  };

  async function SendData() {
    if (!messages.trim()) {
      toast.error("الرجاء كتابة الرد قبل الإرسال");
      return;
    }

    try {
      setLoading(true);
      setErrorMessage("");
      const res = await axiosPrivate.post(`${baseURL}/${SENDRESPONSE}`, {
        id: selectId,
        response: messages,
      });

      toast.success("✅ تم إرسال الرد بنجاح!");
      setmessages("");
      
      // إغلق الـ Modal بعد 1.5 ثانية
      setTimeout(() => {
        setmessage(false);
        resetForm();
        if (onSuccess) {
          onSuccess(); // قم بتحديث البيانات في الصفحة الأم
        }
      }, 1500);
    } catch (err) {
      console.error("Error sending response:", err);
      const errMsg = err.response?.data?.message || 
        "حدث خطأ في إرسال الرد، حاول مجدداً";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {message && (
        <Modal
          show={message}
          onHide={() => {
            if (!loading) {
              setmessage(false);
              resetForm();
            }
          }}
          centered
          dir="rtl"
          backdrop={loading ? "static" : true}
          keyboard={!loading}
        >
          <Modal.Header className="border-0 d-flex justify-content-center position-relative">
            <Modal.Title className="mx-auto">💬 الرد على الاستفسار</Modal.Title>

            {/* زر الإغلاق */}
            {!loading && (
              <div
                onClick={() => {
                  setmessage(false);
                  resetForm();
                }}
                style={{
                  position: "absolute",
                  left: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  width: "28px",
                  height: "28px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                ×
              </div>
            )}
          </Modal.Header>

          <Modal.Body>
            {/* رسالة النجاح */}
            {successMessage && (
              <Alert variant="success" className="mb-3">
                {successMessage}
              </Alert>
            )}

            {/* رسالة الخطأ */}
            {errorMessage && (
              <Alert variant="danger" className="mb-3">
                {errorMessage}
              </Alert>
            )}

            {/* نص الرسالة */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">محتوى الرد</Form.Label>
              <Form.Control
                name="message"
                value={messages}
                onChange={(e) => setmessages(e.target.value)}
                as="textarea"
                rows={5}
                placeholder="اكتب ردك هنا..."
                disabled={loading}
                maxLength={1000}
              />
              <small className="text-muted">
                {messages.length}/1000
              </small>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer className="border-0">
            <Button
              variant="secondary"
              onClick={() => {
                setmessage(false);
                resetForm();
              }}
              disabled={loading}
            >
              إلغاء
            </Button>
            <Button
              variant="success"
              className="w-50"
              onClick={SendData}
              disabled={loading || !messages.trim()}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  جارٍ الإرسال...
                </>
              ) : (
                "✅ إرسال الرد"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
